import style from './DropdownOption.module.scss';
import classNames from 'classnames';
import { Svgicon } from 'components/Svgicon/Svgicon';
import { type SelectDisplayOption } from 'hooks';
import { type FC } from 'react';

type DropdownOptionProps = {
  dataSelectionValue: string,
  onClickOption: (option: SelectDisplayOption) =>
  (event: React.MouseEvent<HTMLDivElement>) => void,
  option: SelectDisplayOption,
  optionContainerStyle?: string,
  optionTextStyle?: string,
  selectedOptionContainerStyle?: string,
  withTickIcon: boolean,
};

export const DropdownOption: FC<DropdownOptionProps> = ({
  dataSelectionValue,
  onClickOption,
  option,
  optionContainerStyle,
  optionTextStyle,
  selectedOptionContainerStyle,
  withTickIcon}) => {
  return (
    <div
      className={classNames(style.option, optionContainerStyle, {
        [selectedOptionContainerStyle as string]: option.selected,
      })}
      data-closest='option'
      data-test={`${dataSelectionValue}-option`}
      id={option.id}
      onClick={onClickOption(option)}
      title={option.name}
    >
      <div className={`${style.optionText} ${optionTextStyle}`}>
        {option.name}
      </div>
      {option.selected && withTickIcon && <Svgicon className='size-[1rem] rotate-180' id='arrow-down' />}
    </div>
  );
};
